import { NewBucket } from "@/types/tao-routing";
import { tokenAxios } from "@/utils/axios";
import { useAppState } from "@/contexts/app-state";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { buildApiUrl } from "@/utils/api";

interface AddNewBucketArgs {
    body: NewBucket;
    practiceId: string;
    requestedUser: string;
}

const postAddBucket = async ({ body, practiceId, requestedUser }: AddNewBucketArgs) => {
    await tokenAxios().post(buildApiUrl("taoManager/addNewBucket"),
        body,
     {
        params: {
            practiceId,
            requestedUser
        }
    });
};

export const useAddBucket = () => {
    const { context, loggedInUser } = useAppState();
    const queryClient = useQueryClient();
    const practiceId = context?.athena?.practiceId ?? "8967";
    const { isPending, isError, isSuccess, mutate } = useMutation({
        mutationFn: postAddBucket,
        onSettled: async () => {
          await queryClient.invalidateQueries({
            queryKey: ["users"],
          });
        },
      });

const addBucket = (body: NewBucket) =>
        mutate({
            body: body,
            practiceId: practiceId,
            requestedUser: loggedInUser,
        });

        return {
            isPending,
            isError,
            isSuccess,
            addBucket,
          };
};
